import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './tailwind.css'

function RootApplication() {
    return (
        <React.StrictMode>
            <App />
        </React.StrictMode>
    )
}

const container = document.getElementById('root')
const root = createRoot(container!)
root.render(<RootApplication />)
